import React, { useMemo, useState } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { Calendar } from "@/components/ui/calendar";
import API from "@/api";
import dayjs from "dayjs";
import { endOfMonth, endOfWeek, startOfMonth, startOfWeek } from "date-fns";
import Button from "@/components/common/Button";
import { RadioGroup } from "@headlessui/react";
import useWindowDimensions from "@/hooks/useWindowDimensions";
import { Plus } from "lucide-react";
import Select from "@/components/common/Select";
import Modal from "@/components/common/Modal";
import { toast } from "react-hot-toast";

const dateOptions = ["Month", "Week", "Day"];

export default function CalendarView() {
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [selectedWeek, setSelectedWeek] = useState({
    // from: startOfMonth(new Date()),
    // to: endOfMonth(new Date()),
  });
  const [period, setPeriod] = useState(dateOptions[2]);
  const currentMonth = selectedDate.getMonth();
  const currentYear = selectedDate.getFullYear();
  const [isOpen, setIsOpen] = useState(false);
  const [fullShift, setFullShift] = useState(true);
  const [rota, setRota] = useState({});
  const [shift, setShift] = useState({});
  const [theHour, setTheHour] = useState({});
  const [teamMember, setTeamMember] = useState("");

  const { width } = useWindowDimensions();
  const queryClient = useQueryClient();

  const monthRotaData = useQuery({
    queryKey: ["rotas", "monthRotaData", currentMonth, currentYear],
    queryFn: () => API.rotas.getMonthData(currentMonth + 1, currentYear),
    staleTime: 2000,
    refetchOnWindowFocus: true,
  });

  const theRota = useMemo(() => {
    if (monthRotaData.isSuccess) {
      return monthRotaData.data.find((item) => item._id === rota) || {};
    }
    return {};
  }, [monthRotaData.isSuccess, monthRotaData.data, rota]);
  const reloadScheduleData = () =>
    queryClient.invalidateQueries(["rotas", "monthRotaData"]);

  const teamMembersFeed = useQuery({
    queryKey: ["allUsersFeed"],
    queryFn: () => API.member.all(),
    staleTime: 2000,
    refetchOnWindowFocus: true,
  });
  const filteredTeamMembers = useMemo(() => {
    if (teamMembersFeed.isSuccess && theRota) {
      return teamMembersFeed.data
        .filter(
          (item) =>
            item.Roles.map((a) => a?.role?.name).indexOf(theRota?.role) !== -1
        )
        .map((item) => {
          return {
            key: item._id,
            value: item.centralId,
            text: item.firstName + " " + item.lastName,
          };
        });
    }
    return [];
  }, [teamMembersFeed.isSuccess, teamMembersFeed.data, theRota]);

  const shiftAdd = (r, s, full, theShift) => {
    setIsOpen(!isOpen);
    setRota(r._id);
    setShift(s);
    setFullShift(full);
    setTheHour(theShift);
  };
  const clearState = () => {
    setIsOpen(false);
    setRota("");
    setShift({});
    setFullShift(true);
    setTheHour({});
    setTeamMember("");
  };
  const handleAssignShift = () => {
    const completeHook = () => {
      setIsOpen(false);
      setTeamMember("");
      setRota("");
      setShift({});
      setFullShift(true);
      setTheHour({});
      reloadScheduleData();
    };
    const hours = [];
    let hourSlot = dayjs(shift.startAt);

    if (!fullShift) {
      if (theHour.empty) {
        hours.push(theHour.start);
      }
    } else {
      while (hourSlot.isBefore(dayjs(shift.endAt))) {
        hours.push(hourSlot.toISOString());
        hourSlot = hourSlot.add(1, "hour");
      }
    }
    API.rotas
      .assignShift(rota, {
        centralId: teamMember,
        hours: hours,
      })
      .then(() => {
        completeHook();
        toast.success("Successfully updated the rota shift");
      })
      .catch((err) => {
        toast.error("There was an unexpected server error.");
      });
  };

  const AddDialog = () => {
    if (isOpen === false) return null;
    return (
      <Modal onClose={() => clearState(false)} title={"Assign Shift"}>
        <Select
          label={"Team Member"}
          options={filteredTeamMembers}
          value={teamMember || ""}
          onChange={(e) => setTeamMember(e.target.value)}
        />
        <div className={"mt-2 border-t pt-2"}>
          <Button
            disabled={teamMember === ""}
            type="submit"
            onClick={handleAssignShift}
            text={"Save changes"}
          />
        </div>
      </Modal>
    );
  };
  return (
    <div className=" ">
      {AddDialog()}
      <div className="  flex w-full flex-wrap gap-6 py-2 lg:flex-nowrap   ">
        <div className=" order-last w-full flex-1 p-2 lg:order-first ">
          {monthRotaData.isSuccess &&
            monthRotaData.data.map((d, i) => {
              return (
                <div key={i} className="border-b-4 border-blue-500 px-2 pt-1">
                  <div className="border-b text-lg font-bold ">{d.role}</div>
                  {d.shifts
                    .filter((s) => {
                      if (period === "Month") {
                        return true;
                      }
                      if (period === "Day") {
                        return (
                          (dayjs(selectedDate).isAfter(
                            dayjs(s.startAt),
                            "day"
                          ) ||
                            dayjs(selectedDate).isSame(
                              dayjs(s.startAt),
                              "day"
                            )) &&
                          (dayjs(selectedDate).isBefore(
                            dayjs(s.endAt),
                            "day"
                          ) ||
                            dayjs(selectedDate).isSame(dayjs(s.endAt), "day"))
                        );
                      } else {
                        return (
                          dayjs(selectedWeek?.from) <= dayjs(s.endAt) &&
                          dayjs(selectedWeek?.to) >= dayjs(s.startAt)
                        );
                      }
                    })
                    .map((s, i) => {
                      return (
                        <div
                          key={i}
                          className={`border-b-2 p-2  ${
                            (dayjs(selectedDate).isAfter(
                              dayjs(s.startAt),
                              "day"
                            ) ||
                              dayjs(selectedDate).isSame(
                                dayjs(s.startAt),
                                "day"
                              )) &&
                            (dayjs(selectedDate).isBefore(
                              dayjs(s.endAt),
                              "day"
                            ) ||
                              dayjs(selectedDate).isSame(
                                dayjs(s.endAt),
                                "day"
                              )) &&
                            "bg-muted/40"
                          } ${
                            dayjs().isAfter(dayjs(s.endAt), "day") &&
                            "text-muted-foreground/40"
                          }`}
                        >
                          <div className="flex justify-between border-b border-dashed text-lg text-muted-foreground">
                            <div
                              className={`${
                                dayjs().isAfter(dayjs(s.endAt), "day") &&
                                "text-muted-foreground/40"
                              }`}
                            >
                              {s.title}
                            </div>
                            <div
                              className={`flex flex-1 items-center justify-end gap-2  ${
                                dayjs().isAfter(dayjs(s.endAt), "day") &&
                                "text-muted-foreground/40"
                              }`}
                            >
                              <div className="text-right">
                                {dayjs(s.startAt).format("DD-MM-YY HH:mm ")}
                              </div>
                              {" - "}
                              <div className="text-right">
                                {dayjs(s.endAt).format("DD-MM-YY HH:mm ")}
                              </div>
                            </div>
                            <div
                              className={`hidden w-32 text-right  text-sm italic md:block ${
                                dayjs().isAfter(dayjs(s.endAt), "day") &&
                                "text-muted-foreground/40"
                              }`}
                            >
                              (
                              {dayjs(s.endAt)
                                .add(1, "hour")
                                .diff(dayjs(s.startAt), "hour")}{" "}
                              hours)
                            </div>
                          </div>
                          <div className="space-y-1 pt-1">
                            {s.hours.length > 0 ? (
                              s.hours.map((h, i) => {
                                return (
                                  <div
                                    key={i}
                                    className="flex justify-between border-b border-dashed indent-4 text-base"
                                  >
                                    <div>
                                      {h.empty ? (
                                        <span
                                          className={`italic text-red-500 ${
                                            dayjs().isAfter(
                                              dayjs(s.endAt),
                                              "day"
                                            ) && "text-muted-foreground/40"
                                          }`}
                                        >
                                          Empty{" "}
                                          {dayjs().isBefore(
                                            dayjs(s.endAt),
                                            "day"
                                          ) && (
                                            <Button
                                              size="sm"
                                              variant="ghost"
                                              className="text-foreground p-1"
                                              onClick={() =>
                                                shiftAdd(d, s, false, h)
                                              }
                                              // text={"Add"}
                                              text={
                                                <Plus className="h-4 w-4 text-green-500" />
                                              }
                                            />
                                          )}
                                        </span>
                                      ) : (
                                        h?.teamMember?.name
                                      )}
                                    </div>
                                    <div
                                      className={`flex flex-1 justify-end  ${
                                        h.empty && "italic text-red-500"
                                      } ${
                                        dayjs().isAfter(
                                          dayjs(s.endAt),
                                          "day"
                                        ) && "text-muted-foreground/40"
                                      }`}
                                    >
                                      <div className="text-right">
                                        {dayjs(h.start).format(
                                          "DD-MM-YY HH:mm"
                                        )}
                                      </div>
                                      {"-"}
                                      <div className="text-right">
                                        {dayjs(h.end)
                                          .add(59, "minute")
                                          .format("DD-MM-YY HH:mm")}
                                      </div>
                                    </div>
                                    <div className="hidden w-32 text-right  text-sm italic md:block">
                                      (
                                      {dayjs(h.end)
                                        .add(1, "hour")
                                        .diff(dayjs(h.start), "hour")}{" "}
                                      hours)
                                    </div>
                                  </div>
                                );
                              })
                            ) : (
                              <div
                                className={`flex gap-1 indent-4 italic text-red-500 ${
                                  dayjs().isAfter(dayjs(s.endAt), "day") &&
                                  "text-muted-foreground/40"
                                }`}
                              >
                                Empty{" "}
                                {dayjs().isBefore(dayjs(s.endAt), "day") && (
                                  <Button
                                    // size="sm"
                                    // variant="ghost"
                                    colour="!border-0 p-1"
                                    onClick={() => shiftAdd(d, s, true)}
                                    text={
                                      <Plus className="h-4 w-4 text-green-500" />
                                    }
                                  />
                                )}
                              </div>
                            )}
                          </div>
                        </div>
                      );
                    })}
                </div>
              );
            })}
        </div>
        <div className=" top-10 mx-auto pr-4 sm:sticky">
          <div className="mb-2">
            <RadioGroup
              value={period}
              onChange={setPeriod}
              className="flex justify-between gap-2 text-center"
            >
              {dateOptions.map((option, i) => (
                <RadioGroup.Option
                  key={option}
                  value={option}
                  className={`flex-1 cursor-pointer rounded border p-2 text-sm ${
                    period === option && "border-green-500 text-green-400"
                  } `}
                >
                  {option}
                </RadioGroup.Option>
              ))}
            </RadioGroup>
          </div>
          <Calendar
            className={"w-full border"}
            max={0}
            min={0}
            mode="single"
            numberOfMonths={width > 1500 ? 2 : 1}
            showOutsideDays
            weekStartsOn={0}
            selected={selectedDate ? selectedDate : new Date()}
            onSelect={(a) => {
              if (period === "Month") {
                setSelectedDate(new Date(a));
                setSelectedWeek({
                  from: startOfMonth(a),
                  to: endOfMonth(a),
                });
              }
              if (period === "Week") {
                setSelectedDate(new Date(a));
                setSelectedWeek({
                  from: startOfWeek(a),
                  to: endOfWeek(a),
                });
              }
              if (period === "Day") {
                setSelectedDate(new Date(a));
              }
            }}
            modifiers={
              period !== "Day" && {
                selected: selectedWeek,
                range_start: selectedWeek?.from,
                range_end: selectedWeek?.to,
              }
            }
            onMonthChange={(a) => {
              setSelectedDate(new Date(a));
            }}
            required
          />
        </div>
      </div>
    </div>
  );
}
